export enum SettingsTabs {
  profile = "profile",
  notifications = "notifications",
  loginAndSecurity = "login&security",
}
